import React from "react";
import MembershipInformation from "./MembershipInformation";
import CompanyAddress from "./CompanyAddress";
import BusinessAccountAndContactInformation from "./BusinessAccountAndContactInformation";
import ErrorBoundary from "../../../common/ErrorBoundary";

const BusinessUserAccount = (props: any) => {
    return (
        <React.Fragment>
            <ErrorBoundary componentName="Membership Information" type="hideError" replaceDefaultContent={false} errorMsg="">
                <MembershipInformation />
            </ErrorBoundary>

            <ErrorBoundary componentName="Business Account And Contact Information" type="hideError" replaceDefaultContent={false} errorMsg="">
                <BusinessAccountAndContactInformation />
            </ErrorBoundary>

            <ErrorBoundary componentName="Company Address" type="hideError" replaceDefaultContent={false} errorMsg="">
                <CompanyAddress />
            </ErrorBoundary>
        </React.Fragment>
    );
};

export default BusinessUserAccount;
